import React, { useEffect, useState } from "react";
import { getStudents } from "../../../services/admin.services";

const ApplicationsCard = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [application, setApplication] = useState({
    total_applications: 0,
    Pending_Application: 0,
    Pending_University: 0,
    Complete: 0,
  });

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await getStudents();
        setApplication({
          total_applications: response.data.Total_Application || 0,
          Pending_Application: response.data.Pending_Application || 0,
          Pending_University: response.data.Pending_University || 0,
          Complete: response.data.Complete || 0,
        });
      } catch (error) {
        console.error("Error fetching students:", error);
      }
    };

    fetchStudents();
  }, []);

  return (
    <div className="p-1 sm:p-3 md:p-4">
      <div className="overflow-hidden rounded-2xl border border-indigo-100 bg-white shadow-sm">
        <div className="flex items-center justify-between border-b border-slate-200 bg-slate-50/70 px-4 py-3 sm:px-5">
          <h2 className="text-lg font-bold text-slate-800 sm:text-xl md:text-2xl">
            Applications
          </h2>
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="rounded-lg px-3 py-1.5 text-xs font-medium text-slate-600 transition-colors hover:bg-slate-200 sm:text-sm"
          >
            {isExpanded ? "Hide ▲" : "Show ▼"}
          </button>
        </div>

        {isExpanded && (
          <div className="grid grid-cols-1 gap-4 p-4 sm:grid-cols-2 sm:gap-5 sm:p-5 lg:grid-cols-4 lg:gap-6">
            {/* New Applications */}
            <div className="group rounded-2xl border border-emerald-300/40 bg-gradient-to-br from-emerald-400 to-emerald-500 p-4 text-center text-white shadow-sm transition-transform hover:-translate-y-0.5">
              <p className="p-1 text-base font-semibold sm:text-lg">
                New Applications
              </p>
              <p className="py-4 text-4xl font-bold tracking-tight sm:py-6 sm:text-5xl">
                {application.total_applications}
              </p>
            </div>

            {/* Pending Applications */}
            <div className="group rounded-2xl border border-blue-300/40 bg-gradient-to-br from-blue-400 to-blue-500 p-4 text-center text-white shadow-sm transition-transform hover:-translate-y-0.5">
              <p className="p-1 text-base font-semibold sm:text-lg">
                Pending Applications
              </p>
              <p className="py-4 text-4xl font-bold tracking-tight sm:py-6 sm:text-5xl">
                {application.Pending_Application}
              </p>
            </div>

            {/* Pending University */}
            <div className="group rounded-2xl border border-teal-300/40 bg-gradient-to-br from-teal-500 to-emerald-600 p-4 text-center text-white shadow-sm transition-transform hover:-translate-y-0.5">
              <p className="p-1 text-base font-semibold sm:text-lg">
                Pending University
              </p>
              <p className="py-4 text-4xl font-bold tracking-tight sm:py-6 sm:text-5xl">
                {application.Pending_University}
              </p>
            </div>

            {/* Completed Applications */}
            <div className="group rounded-2xl border border-rose-300/40 bg-gradient-to-br from-rose-400 to-red-500 p-4 text-center text-white shadow-sm transition-transform hover:-translate-y-0.5">
              <p className="p-1 text-base font-semibold sm:text-lg">
                Completed Applications
              </p>
              <p className="py-4 text-4xl font-bold tracking-tight sm:py-6 sm:text-5xl">
                {application.Complete}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicationsCard;
